<template>
	<BaseLayout :footer-full="true">
		<NewUserRewardContent />
	</BaseLayout>
</template>
<script setup lang="ts">
import NewUserRewardContent from '@components/legal/new-user-reward-content.vue';
</script>
